// extracted by mini-css-extract-plugin
export var askAiIcon = "_lz-j";
export var category = "_lz-9";
export var categoryHeader = "_lz-e";
export var container = "_lz-0";
export var group = "_lz-a";
export var groupItems = "_lz-f";
export var groupSeparator = "_lz-k";
export var loading = "_lz-1";
export var noResults = "_lz-3";
export var placeholder = "_lz-2";
export var resultContent = "_lz-5";
export var resultIcon = "_lz-c";
export var resultItem = "_lz-g";
export var resultMeta = "_lz-8";
export var resultSubtitle = "_lz-7";
export var resultSuffix = "_lz-i";
export var resultTitle = "_lz-6";
export var resultsList = "_lz-4";
export var searchGroup = "_lz-d";
export var selected = "_lz-h";
export var subgroup = "_lz-b";